import {createSlice} from "@reduxjs/toolkit";

const userSlice = createSlice({
  name:'user',
  initialState:{
    user:null,
    registrationData:null,
    isLoading:false,
    error:null,
    isAuthenticated:false,
    userPermissions:null,
    userRole:null,
    isMainVendor: false,
    systemPermissions: null,
    systemPermissionsLoading: false,
    systemPermissionsError: null,
  },
  reducers:{
    setUser:(state,action)=>{
      console.log('setUser action called with:', action.payload);
      state.user = action.payload;
      state.isAuthenticated = true;
      
      //* Check if user is main vendor based on API response
      const isMainVendor = action.payload?.is_main_vendor === "true" || 
                          action.payload?.is_main_vendor === true ||
                          action.payload?.is_main_vendor === 1;
      
      state.isMainVendor = isMainVendor;
      
      if (isMainVendor) {
        //* Main vendor has all permissions (empty array indicates full access)
        state.userPermissions = null;
        state.userRole = 'main_vendor';
      } else {
        const permissions = action.payload?.permissions || [];
        
        // Handle the new API format where permissions is a simple array of strings
        if (Array.isArray(permissions)) {
          if (permissions.length > 0 && typeof permissions[0] === 'string') {
            // Simple array format like ["View_Deals"]
            const groupedPermissions = {};
            
            // Map permissions to their respective modules
            permissions.forEach(permission => {
              switch(permission) {
                case 'View_Deals':
                  if (!groupedPermissions['Deals_Management']) {
                    groupedPermissions['Deals_Management'] = [];
                  }
                  groupedPermissions['Deals_Management'].push('View_Deals');
                  break;
                case 'Create_Offer':
                  if (!groupedPermissions['Deals_Management']) {
                    groupedPermissions['Deals_Management'] = [];
                  }
                  groupedPermissions['Deals_Management'].push('Create_Offer');
                  break;
                case 'Edit_Offer':
                  if (!groupedPermissions['Deals_Management']) {
                    groupedPermissions['Deals_Management'] = [];
                  }
                  groupedPermissions['Deals_Management'].push('Edit_Offer');
                  break;
                case 'Delete_Offer':
                  if (!groupedPermissions['Deals_Management']) {
                    groupedPermissions['Deals_Management'] = [];
                  }
                  groupedPermissions['Deals_Management'].push('Delete_Offer');
                  break;
                case 'Blast_Deal':
                  if (!groupedPermissions['Deals_Management']) {
                    groupedPermissions['Deals_Management'] = [];
                  }
                  groupedPermissions['Deals_Management'].push('Blast_Deal');
                  break;
                case 'View_Partners':
                  if (!groupedPermissions['Partner_Management']) {
                    groupedPermissions['Partner_Management'] = [];
                  }
                  groupedPermissions['Partner_Management'].push('View_Partners');
                  break;
                case 'Create_Partner':
                  if (!groupedPermissions['Partner_Management']) {
                    groupedPermissions['Partner_Management'] = [];
                  }
                  groupedPermissions['Partner_Management'].push('Create_Partner');
                  break;
                case 'Edit_Partner':
                  if (!groupedPermissions['Partner_Management']) {
                    groupedPermissions['Partner_Management'] = [];
                  }
                  groupedPermissions['Partner_Management'].push('Edit_Partner');
                  break;
                case 'Delete_Partner':
                  if (!groupedPermissions['Partner_Management']) {
                    groupedPermissions['Partner_Management'] = [];
                  }
                  groupedPermissions['Partner_Management'].push('Delete_Partner');
                  break;
                case 'Redeem_Offers':
                  if (!groupedPermissions['Redeem_Offers']) {
                    groupedPermissions['Redeem_Offers'] = [];
                  }
                  groupedPermissions['Redeem_Offers'].push('Redeem_Offers');
                  break;
                case 'Redeem_Edit':
                  if (!groupedPermissions['Redeem_Offers']) {
                    groupedPermissions['Redeem_Offers'] = [];
                  }
                  groupedPermissions['Redeem_Offers'].push('Redeem_Edit');
                  break;
                case 'Redeem_Delete':
                  if (!groupedPermissions['Redeem_Offers']) {
                    groupedPermissions['Redeem_Offers'] = [];
                  }
                  groupedPermissions['Redeem_Offers'].push('Redeem_Delete');
                  break;
                case 'View_Reports_Analytics':
                  if (!groupedPermissions['Deals_Analytics']) {
                    groupedPermissions['Deals_Analytics'] = [];
                  }
                  groupedPermissions['Deals_Analytics'].push('View_Reports_Analytics');
                  break;
                case 'View_Subscription':
                  if (!groupedPermissions['Subscription']) {
                    groupedPermissions['Subscription'] = [];
                  }
                  groupedPermissions['Subscription'].push('View_Subscription');
                  break;
                case 'Purchase_Subscription':
                  if (!groupedPermissions['Subscription']) {
                    groupedPermissions['Subscription'] = [];
                  }
                  groupedPermissions['Subscription'].push('Purchase_Subscription');
                  break;
                case 'View_Subscription_History':
                  if (!groupedPermissions['Subscription']) {
                    groupedPermissions['Subscription'] = [];
                  }
                  groupedPermissions['Subscription'].push('View_Subscription_History');
                  break;
                case 'Role_View':
                  if (!groupedPermissions['Roles_Permission']) {
                    groupedPermissions['Roles_Permission'] = [];
                  }
                  groupedPermissions['Roles_Permission'].push('Role_View');
                  break;
                case 'Role_Create':
                  if (!groupedPermissions['Roles_Permission']) {
                    groupedPermissions['Roles_Permission'] = [];
                  }
                  groupedPermissions['Roles_Permission'].push('Role_Create');
                  break;
                case 'Role_Edit':
                  if (!groupedPermissions['Roles_Permission']) {
                    groupedPermissions['Roles_Permission'] = [];
                  }
                  groupedPermissions['Roles_Permission'].push('Role_Edit');
                  break;
                case 'Role_Delete':
                  if (!groupedPermissions['Roles_Permission']) {
                    groupedPermissions['Roles_Permission'] = [];
                  }
                  groupedPermissions['Roles_Permission'].push('Role_Delete');
                  break;
                default:
                  // Handle any other permissions
                  console.warn(`Unknown permission: ${permission}`);
                  break;
              }
            });
            
            state.userPermissions = groupedPermissions;
          } else if (typeof permissions[0] === 'object' && permissions[0].module) {
            // Old format with module objects
            const groupedPermissions = {};
            permissions.forEach(permission => {
              const module = permission.module;
              if (!groupedPermissions[module]) {
                groupedPermissions[module] = [];
              }
              groupedPermissions[module].push(permission.name);
            });
            state.userPermissions = groupedPermissions;
          } else {
            // Direct permissions array
            state.userPermissions = permissions;
          }
        } else {
          state.userPermissions = {};
        }
        
        state.userRole = action.payload?.role || 'team_member';
      }
    },
    clearUser: (state)=>{
      state.user = null;
      state.registrationData = null;
      state.isAuthenticated = false;
      state.userPermissions = null;
      state.userRole = null;
      state.isMainVendor = false;
    },
    setRegistrationData: (state, action) => {
      state.registrationData = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateUserPermissions: (state, action) => {
      state.userPermissions = action.payload;
    },
    updateUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    // New actions for system permissions
    setSystemPermissionsLoading: (state, action) => {
      state.systemPermissionsLoading = action.payload;
    },
    setSystemPermissions: (state, action) => {
      state.systemPermissions = action.payload;
      state.systemPermissionsLoading = false;
      state.systemPermissionsError = null;
    },
    setSystemPermissionsError: (state, action) => {
      state.systemPermissionsError = action.payload;
      state.systemPermissionsLoading = false;
    },
    // Helper actions for permission checking
    canUserAccessModule: (state, action) => {
      const { module, requiredAction } = action.payload;
      
      // Main vendor has full access
      if (state.isMainVendor) {
        return true;
      }
      
      // Check team member permissions
      if (!state.userPermissions || !state.userPermissions[module]) {
        return false;
      }
      
      return state.userPermissions[module].includes(requiredAction);
    }
  }
})

export const {
  setUser,
  clearUser,
  setRegistrationData,
  setLoading,
  setError,
  updateUserPermissions,
  updateUserRole,
  setSystemPermissionsLoading,
  setSystemPermissions,
  setSystemPermissionsError,
  canUserAccessModule
} = userSlice.actions;

export default userSlice.reducer;

